import { createSelector } from "@reduxjs/toolkit"
import { combineReducers } from "redux"

import { clientsReducer } from "./clients"
import { driversReducer } from "./drivers"
import { globalReducer } from "./global"
import { notificationsReducer } from "./notifications"
import { ordersReducer } from "./orders"
import { paymentsReducer } from "./payments"
import { teamsReducer } from "./teams"
import { teamsStatsReducer } from "./teamsStats"
import { uiReducer } from "./ui"
import { userReducer } from "./user"

export const rootReducer = combineReducers({
  user: userReducer,
  clients: clientsReducer,
  teams: teamsReducer,
  drivers: driversReducer,
  orders: ordersReducer,
  payments: paymentsReducer,
  notifications: notificationsReducer,
  teamsStats: teamsStatsReducer,
  global: globalReducer,
  ui: uiReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export const selectCount = (selector: (state: RootState) => unknown[]) =>
  createSelector(selector, (collection) => collection.length)
